// Module
var code = "<div id=\"page-title\"> <div class=\"d-flex align-items-center\"> <h4 class=\"title\" id=\"title\">Titre</h4> </div> <div class=\"tabs-container\"> </div> </div> <div id=\"page-content\" class=\"p-3 h-100 w-100 d-flex flex-column\"> </div>";
// Exports
export default code;